import { ref, watch, getCurrentInstance } from 'vue';

export function useFiltroSelect({ filtro, path, items, onAtualizarCustom = null }) {
  const { proxy } = getCurrentInstance();
  const selectedItem = ref({ id: '', name: '' });

  function aplicarPadrao(item) {
    proxy.$aplicaFiltroEmURL(filtro.value.filtro, item.id, path.value);
    proxy.$store.commit('addFiltro', filtro.value);
    proxy.$store.commit('addFiltroAplicado', {
      filtro: filtro.value.filtro,
      valor: item.id,
    });
  }

  function onAtualizar(item) {
    selectedItem.value = item;
    if (onAtualizarCustom) {
      onAtualizarCustom(item);
      return;
    }
    aplicarPadrao(item);
  }

  watch(items, (novos) => {
    if (!novos || !novos.length) return;
    const aplicado = proxy.$store.state.filtroAplicados[filtro.value.filtro];
    proxy.$renderFiltroSelect(aplicado, novos, selectedItem.value);
  }, { immediate: true });

  return { selectedItem, onAtualizar };
}
